import '../styles/cartSummary.css';
import { useTranslation } from 'react-i18next';

const CartSummary = ({ subscription, addons, interval, taxResult, isCalculatingTax }) => {
    const { t } = useTranslation();

    if (!subscription) return null;

    const formatPrice = (price) =>
        `${price.currency === 'eur' ? '€' : price.currency.toUpperCase()} ${(price.unitAmount / 100).toFixed(2)}`;

    const subtotal =
        subscription.quantity * subscription.price.unitAmount +
        addons.reduce(
            (sum, addon) => sum + addon.quantity * addon.price.unitAmount,
            0
        );

    const recurringTotal =
        subscription.quantity * subscription.price.unitAmount +
        addons
            .filter(addon => addon?.price?.type !== 'one_time')
            .reduce(
                (sum, addon) =>
                    sum + addon.quantity * addon.price.unitAmount,
                0
            );

    const taxPercentageNumber = taxResult?.taxRateDecimal ? parseFloat(taxResult.taxRateDecimal) : 0;

    return (
        <div className="cart-summary">
            <div className="cart-header">
                <h2>{t('subscribe_to')} {subscription.name}</h2>
                <div className="cart-total">
                    {subscription?.price.currency === 'eur' ? '€' : subscription?.price.currency.toUpperCase()} {taxResult?.total ?(taxResult?.total / 100).toFixed(2) : (subtotal / 100).toFixed(2)}
                    <span>{t('afterwards')} {subscription?.price.currency === 'eur' ? '€' : subscription?.price.currency.toUpperCase()} {((recurringTotal/100).toFixed(2) * (taxPercentageNumber / 100 + 1)).toFixed(2)} {interval === 'year' ? t('billed_annually') : t('billed_monthly')}</span>
                </div>
            </div>

            <div className="cart-items">
                <div className="cart-item">
                    <div className="cart-item-info">
                        <strong>{subscription.name}</strong>
                        <div className="cart-item-meta">
                            {t('quantity')} {subscription.quantity}, {interval === 'year' ? t('billed_annually') : t('billed_monthly')}
                        </div>
                    </div>
                    <div className="cart-item-price">
                        {formatPrice(subscription.price)}
                    </div>
                </div>

                {addons.map(addon => (
                    <div className="cart-item" key={addon.id}>
                        <div className="cart-item-info">
                            <strong>{addon.name}</strong>
                            <div className="cart-item-meta">
                                {t('quantity')} {addon.quantity}, {addon?.price?.type === 'one_time' ? t('one_time') :(interval === 'year' ? t('billed_annually') : t('billed_monthly'))}
                            </div>
                        </div>
                        <div className="cart-item-price">
                            {formatPrice(addon.price)}
                        </div>
                    </div>
                ))}
            </div>

            { isCalculatingTax ?
                <div style={{textAlign: 'center', color: 'white'}}>{t("calculating_tax")}</div>:
                <div className="cart-footer">
                    <div className="cart-row">
                        <span>{t('subtotal')}</span>
                        <span>{subscription?.price.currency === 'eur' ? '€' : subscription?.price.currency.toUpperCase()} {(subtotal / 100).toFixed(2)}</span>
                    </div>

                    <div className="cart-row tax">
                        <span>{t('tax') + " (" + (taxPercentageNumber)+"%)"}</span>
                        <span>{subscription?.price.currency === 'eur' ? '€' : subscription?.price.currency.toUpperCase()} {(taxResult?.tax / 100).toFixed(2)}</span>
                    </div>

                    <div className="cart-row total">
                        <span>{t('total_due_today')}</span>
                        <span>{subscription?.price.currency === 'eur' ? '€' : subscription?.price.currency.toUpperCase()} {taxResult?.total ? (taxResult?.total / 100).toFixed(2) : (subtotal / 100).toFixed(2)}</span>
                    </div>
                </div>
            }
        </div>
    );
};

export default CartSummary;